(function($) {

	"use strict";

/** --------------------------------------------------
 *
 *   THEME SCRIPT
 *
 *   TABLE OF CONTENTS
 *   document ready
 *   window load
 *   drupal behavior
 *
 *  -------------------------------------------------- */




/** --------------------------------------------------
    #document ready
    -------------------------------------------------- */

	$(document).ready(function() {

		const $body = $('body');

		if($body.hasClass('node--type-series') || $body.hasClass('node--type-product')) {


			selectProductDetail();


			/* Sticky header on the product detail page */
			/* $('.clarysse-commerce__dynamic-add-to-cart + div').waypoint({
				handler: function(direction) {
					$body.toggleClass('sticky-header-active');
				},
				offset: 100
			}); */

			$(document).on('click', '.js-sticky-header-add-to-cart, .clarysse-custom__buy-now', function(){

				if (window.matchMedia("(max-width: 975px)").matches) {
					$('html,body').animate({scrollTop: $('#dynamic-add-to-cart-form-main-wrapper-inner .product-detail__scroll + div').offset().top},'slow');
				} else {
					$('html,body').animate({scrollTop: $('.clarysse-commerce-dynamic-add-to-cart-form').offset().top},'slow');
				}

			});


		}

	});




	Drupal.behaviors.colorselect = {
		attach: function (context, settings) {


			selectProductDetail();


		}
	};




	function selectProductDetail() {

		/* Select list with a color item */
			$.widget("custom.colorselectmenu", $.ui.selectmenu, {
				_renderItem: function( ul, item ) {
					let li = $('<li>'),
						wrapper = $('<div>', { text: item.label } );

					$('<span>', {
						style: 'background-color: #' + item.element.attr('data-color-code') + '; border-color: #' + item.element.attr('data-border-color-code'),
						'class': 'color-dot'
					}).prependTo(wrapper);

					return li.append(wrapper).appendTo(ul);
				},

				_renderButtonItem: function( item ) {
					let buttonItem = $('<span>', {
						'class': "ui-selectmenu-text",
						text: item.label
					});

					let colorDot = $('<span>', {
						style: 'background-color: #' + item.element.attr('data-color-code') + '; border-color: #' + item.element.attr('data-border-color-code'),
						'class': 'color-dot'
					}).prependTo(buttonItem);

					return buttonItem;
				}
			});



			$('.product-detail__right .form-item-color select').colorselectmenu({
				select: function( event, ui ) {
					document.querySelector('[id^="edit-color"]').dispatchEvent(new Event('change'));
				}
			});


			/* Select list with a product type item */
			$('.product-detail__right .form-item-product select').selectmenu({
				select: function( event, ui ) {
					document.querySelector('[id^="edit-product"]').dispatchEvent(new Event('change'));
				}
			});

	}


})(jQuery);
